import { call, put, takeEvery, all, select } from "redux-saga/effects";
import { studyActions } from "./studySlice";
import { assignCourse, getSynonyms } from "./studyBaseApi";
import { toastAction } from "../toast/toast";
import { getNextCourse } from "../course/courseSlice";

function* onCourseAssignment({ payload }) {
  try {
    yield call(assignCourse, payload);

    // Determine the success message based on nextCourse data stored in the course slice.
    const nextCourse = yield select(getNextCourse);
    let message;
    if (Object.keys(nextCourse).length == 0) {
      message = "Level Assigned";
    } else {
      message = nextCourse.newLevel
        ? "Next Level Assigned"
        : "Course completed successfully";
    }

    yield put(toastAction.onSuccToast(message));
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message || error.error));
  }
}

function* onSynonymsLoad({ payload }) {
  yield put(studyActions.setSynonymsLoading(true));

  try {
    if (
      !payload ||
      !payload.words ||
      !Array.isArray(payload.words) ||
      !payload.words.length
    ) {
      yield put(studyActions.setSynonyms([]));
      return;
    }

    const synonymPromises = payload.words.map(function* (word) {
      try {
        const syn = yield call(getSynonyms, word); // Using yield to wait for the async call
        return syn.data;
      } catch (error) {
        return { word, synonyms: [], glossary: "" };
      }
    });

    const results = yield all(synonymPromises); // Using `yield all` to resolve all promises
    const synonymsMap = results.reduce((acc, syn) => {
      acc[syn.word] = syn;
      return acc;
    }, {});

    yield put(studyActions.setSynonyms(Object.values(synonymsMap)));
  } catch (error) {
    yield put(toastAction.onErrorToast(error?.message || error.error));
  } finally {
    yield put(studyActions.setSynonymsLoading(false));
  }
}

function* studyWatcherSaga() {
  yield takeEvery(studyActions.assignCourse.type, onCourseAssignment);
  yield takeEvery(studyActions.loadSynonyms.type, onSynonymsLoad);
}

export default studyWatcherSaga;
